import * as Cesium from 'cesium'

export function addProblematicWaterArea(coordinates: number[][]): Cesium.GroundPrimitive {
  const positions = Cesium.Cartesian3.fromDegreesArray(coordinates.flat())

  const geometryInstance = new Cesium.GeometryInstance({
    geometry: new Cesium.PolygonGeometry({
      polygonHierarchy: new Cesium.PolygonHierarchy(positions),
      vertexFormat: Cesium.VertexFormat.POSITION_AND_COLOR,
    }),
    attributes: {
      color: Cesium.ColorGeometryInstanceAttribute.fromColor(Cesium.Color.RED.withAlpha(0.5)),
    },
  })

  const groundPrimitive = new Cesium.GroundPrimitive({
    geometryInstances: geometryInstance,
    appearance: new Cesium.PerInstanceColorAppearance({
      flat: true,
      translucent: true,
    }),
  })
  return groundPrimitive
}

export function removeProblematicWaterArea(
  viewer: Cesium.Viewer,
  entities: { area?: Cesium.Primitive; label?: Cesium.Entity }
): void {
  if (!entities) return

  if (entities.area) {
    viewer.scene.primitives.remove(entities.area)
  }

  if (entities.label) {
    viewer.entities.remove(entities.label)
  }
}
